import React, { Component } from 'react'
import { connect } from 'react-redux'
import { isEqual } from 'lodash'

// import actions
import { getQualityCheckSettings, getAgreementQualityCheckSettings, updateQualityCheckSettings } from '../../../actions/qualitychecksettings'
import { getShopCustomerAgreement, getPriceList } from '../../../actions/priceModel'

import { getBrands } from '../../../actions/common'
// Utils
import { hasAccess } from '../../../utils/auth'
import { translation } from '../../../utils/helpers'

// import components
import Portal from '../../../shared/components/Portal'
import Confirm from '../../../shared/components/Confirm'
import QualityCheckSettingsBox from './QualityCheckSettingsBox'

import Row from '../../../shared/elements/row'
import Col from '../../../shared/elements/col'
import Panel from '../../../shared/elements/panel'
import Radio from '../../../shared/elements/radio'
import Text from '../../../shared/elements/text'
import Switch from '../../../shared/elements/switch'
import Inline from '../../../shared/elements/inline'
import RemoveButton from '../../../shared/elements/removeButton'
import DropDown from '../../../shared/elements/dropDown'
import AddButton from '../../../shared/elements/addButton'
import Button from '../../../shared/elements/button'
import Divider from '../../../shared/elements/divider'

import './index.scss'
import '../qualitychecksettings.scss'

class QualityCheckSettingsChild extends Component {
  constructor (props) {
    super(props)
    this.state = {
      activeItem: {
        Active: true,
        BrandSelectionType: 0,
        ChainId: 0,
        ShopId: 0,
        IsDeleted: false,
        Name: null,
        PriceModelId: 0,
        QualityCheckBrands: [],
        QualityCheckCustomers: [],
        QualityCheckModelId: 0,
        QualityCheckOrderType: 1,
        QualityCheckTasks: this.generateEmptyTasks(),
        QualityCheckTaskGroups: [],
        Department: 0
      },
      CurrentBrand: '0',
      CurrentCustomer: '0',
      confirmDelete: {
        open: false
      },
      isAgreement: props.isAgreement === true,
      isMainAgreement: this.props.isMainAgreement === true,
      disabled: false,
      isLoaded: false,
      price: props.isAgreement === true ? (props.agreementPrice !== undefined ? props.agreementPrice : {}) : {},

      dimensions: {}
    }
    this.getQualityCheckSettings = this.getQualityCheckSettings.bind(this)
    this.updateQualityCheckSettings = this.updateQualityCheckSettings.bind(this)
    this.changeType = this.changeType.bind(this)
    this.onInputChange = this.onInputChange.bind(this)
    this.onInputBlur = this.onInputBlur.bind(this)
    this.generateEmptyTasks = this.generateEmptyTasks.bind(this)
    this.resetCreate = this.resetCreate.bind(this)
    this.updateDimensions = this.updateDimensions.bind(this)
  }
  resetCreate () {
    this.setState({
      activeItem: {
        Active: true,
        BrandSelectionType: 0,
        ChainId: 0,
        ShopId: 0,
        IsDeleted: false,
        Name: null,
        PriceModelId: 0,
        QualityCheckBrands: [],
        QualityCheckCustomers: [],
        QualityCheckModelId: 0,
        QualityCheckOrderType: 1,
        QualityCheckTasks: this.generateEmptyTasks(),
        QualityCheckTaskGroups: [],
        Department: 0
      },
      CurrentBrand: '0',
      CurrentCustomer: '0',
      confirmDelete: {
        open: false
      },
      price: this.props.isAgreement === true ? (this.props.agreementPrice !== undefined ? this.props.agreementPrice : {}) : {},
      isAgreement: this.props.isAgreement === true,
      isMainAgreement: this.props.isMainAgreement === true,
      disabled: false,
      isLoaded: false
    })
  }
  generateEmptyTasks () {
    let tasks = []
    for (let i = 1; i < 8; i++) {
      for (let j = 1; j < 5; j++) {
        tasks.push({
          ModifiedEnd: false,
          ModifiedStart: false,
          PerformAtEnd: false,
          PerformAtStart: false,
          QualityCheckTaskId: 0,
          QualityCheckTaskType: j,
          StepNr: i
        })
      }
    }
    return tasks
  }
  getCustomerAgreement (agreementId, customerId, companyId) {
    // console.log('getCustomerAgreement', agreementId, customerId)
    this.resetCreate()
    if (this.state.price !== undefined && this.state.price.PriceModelId !== undefined) {
      this.getQualityCheckSettings(this.state.price.PriceModelId)
      return
    }

    this.props.getShopCustomerAgreement(agreementId, customerId, companyId).then((res) => {
      let { activeItem } = { ...this.state }
      activeItem.PriceModelId = res.data.PriceModelId
      this.setState({
        price: res.data,
        activeItem: activeItem
      }, () => {
        this.getQualityCheckSettings(this.state.price.PriceModelId)
      })
    }, () => {
      // Toastr
      window.toastr.error(translation('13445'), translation('216'))
      this.props.onShouldUpdate()
    })
  }
  getAgreement (agreementId) {
    // console.log('getAgreement', agreementId)
    this.resetCreate()
    this.props.getPriceList(agreementId).then((res) => {
      let { activeItem } = { ...this.state }
      activeItem.PriceModelId = res.data.PriceModelId
      this.setState({
        price: res.data,
        activeItem: activeItem
      }, () => {
        this.getQualityCheckSettings(this.state.price.PriceModelId)
      })
    }, () => {
      // Toastr
      window.toastr.error(translation('13445'), translation('216'))
      this.props.onShouldUpdate()
    })
  }
  componentDidMount () {
    // if (!this.hasAccessToPage()) {
    //   this.props.router.push('/prices')
    // console.log(this.state)
    if (this.state.isAgreement && this.state.agreementPrice !== undefined) {
      this.getQualityCheckSettings(this.state.agreementPrice.PriceModelId)
    } else if (!this.state.isAgreement && !this.state.isMainAgreement) {
      this.getQualityCheckSettings(this.props.params.type)
    } else if (this.state.isAgreement && !this.state.isMainAgreement) {
      this.getCustomerAgreement(this.props.agreementId, this.props.selectedCustomerId, this.props.selectedShopId)
    } else if (this.state.isMainAgreement && !this.state.isAgreement) {
      this.getAgreement(this.props.agreementId)
    }
    let { brands } = this.props
    if (brands.length === 0) {
      this.props.getBrands()
    }

    window.addEventListener('resize', this.updateDimensions)
  }

  componentWillUnmount () {
    window.removeEventListener('resize', this.updateDimensions)
  }

  componentWillReceiveProps (nextProps) {
    if (!this.state.isAgreement && !isEqual(nextProps.params.type, this.props.params.type)) {
      this.getQualityCheckSettings(nextProps.params.type)
    }
    if (this.state.isAgreement && !isEqual(this.props.agreementPrice.PriceModelId, nextProps.agreementPrice.PriceModelId) && isEqual(nextProps.selectedCustomerId, this.props.selectedCustomerId)) {
      this.getQualityCheckSettings(nextProps.agreementPrice.PriceModelId)
    }
    if (this.state.isMainAgreement && !isEqual(nextProps.params.type, this.props.params.type)) {
      this.getAgreement(this.props.agreementId)
    }
    let { brands } = this.props
    if (brands.length === 0) {
      this.props.getBrands()
    }
  }

  updateDimensions () {
    if (!this.qualityRef) {
      return
    }

    this.setState({
      dimensions: {
        width: this.qualityRef.clientWidth,
        height: this.qualityRef.clientHeight
      }
    })
  }

  dimensionShow (dimensions) {
    let show = false
    dimensions.map((val, key) => {
      if (!show) {
        let higherThan = val[0]
        let lessThan = val[1]
        let width = this.state.dimensions.width
        if (width > higherThan && width <= lessThan) show = true
      }
    })
    return show
  }

  updateQualityCheckSettings (data) {
    return this.props.updateQualityCheckSettings(data).then((res) => {
      this.props.updateList()
      this.setState({
        activeItem: res.data
      })
      // Toastr
      // window.toastr.success(translation('1813'), translation('13424'))
      return res
    }, (err) => {
      // Toastr
      window.toastr.error(translation('1814'), translation('216'))
      return err
    })
  }

  getQualityCheckSettings (id) {
    this.resetCreate()
    // console.log('Get quality model id ', id)
    if (this.state.isAgreement || this.state.isMainAgreement) {
      this.props.getAgreementQualityCheckSettings(id).then((res) => {
        this.setState({
          activeItem: res.data,
          isLoaded: true
        })
        // console.log('Received model: ', res.data)
        return res
      }, () => {
        console.log('Err fetching quality check model data')
        return null
      })
    } else if (!this.state.isAgreement && !this.state.isMainAgreement) {
      this.props.getQualityCheckSettings(id).then((res) => {
        this.setState({
          activeItem: res.data,
          disabled: res.data.PriceModelId > 0,
          isLoaded: true
        })
        // console.log('Received model: ', res.data)
        return res
      }, () => {
        console.log('Err fetching quality check model data')
        return null
      })
    }
  }

  changeType (e) {
    let value = parseInt(e.target.value)
    this.setState({
      activeItem: {
        ...this.state.activeItem,
        [e.target.name]: value
      }
    }, () => {
      this.updateQualityCheckSettings(this.state.activeItem)
    })
  }

  onInputChange (e) {
    e.persist()
    let value = e.target.value
    if (e.target.type === 'checkbox') {
      value = e.target.checked
    }
    this.setState({
      activeItem: {
        ...this.state.activeItem,
        [e.target.name]: value
      }
    }, () => {
      if (e.target.type === 'checkbox') {
        this.updateQualityCheckSettings(this.state.activeItem).then((res) => {
          if (e.target.name === 'Active') {
            this.props.updateList()
          }
        })
      }
    })
  }

  onInputBlur (e) {
    e.persist()
    // if (this.shouldUpdatePrices(this.state.price[e.target.name], this.state.priceOriginal[e.target.name])) {
    this.updateQualityCheckSettings(this.state.activeItem).then((res) => {
      if (e.target.name === 'Name') {
        this.props.updateList()
      }
    })
    // }
  }

  renderBrands () {
    // if (this.state.activeItem === undefined) return null
    if (hasAccess([6], this.props.auth.user.UserType) && !this.state.isAgreement) return null
    let quality = this.state.activeItem
    let { brands } = this.props
    // Add customers
    const addItem = () => {
      if (this.state.disabled) return null
      let id = parseInt(this.state.CurrentBrand)
      if (id !== 0) {
        let quality = { ...this.state.activeItem }
        quality.QualityCheckBrands.push({
          BrandNameId: id
        })
        this.updateQualityCheckSettings(quality).then(() => {
          this.setState({
            CurrentBrand: '0'
          })
        })
      }
    }
    const onChange = (e) => {
      if (e.target.name === 'brands') {
        this.setState({
          CurrentBrand: e.target.value
        })
      }
    }
    // Render brand
    const renderBrand = (val, key) => {
      // Delete item
      const deleteItem = (e) => {
        let disabled = { ...this.state.disabled }
        if (disabled === true) return null
        quality.QualityCheckBrands[key].Active = false
        this.updateQualityCheckSettings(quality)
      }
      // Return
      return (
        <Inline key={key} block fillChildNum={[0]}>
          {val.BrandName}
          {!this.state.disabled && (<RemoveButton minus size='m' onClick={deleteItem} />)}
        </Inline>
      )
    }
    // Return
    return (
      <div className='brand-selection'>
        <Panel title={translation('145')} helpText={translation('1940')}>
          <Radio id='brands_all' name='BrandSelectionType' value='0' onChange={this.changeType} checked={quality.BrandSelectionType === 0} disabled={this.state.disabled} labelText={translation('381')} />
          <Radio id='brands_selected' name='BrandSelectionType' value='1' onChange={this.changeType} checked={quality.BrandSelectionType === 1} disabled={this.state.disabled} labelText={translation('13475')} />

          {quality.BrandSelectionType === 1 && (
            <div>
              {quality.QualityCheckBrands.map(renderBrand)}
              <Inline block fillChildNum={[0]}>
                {!this.state.disabled && (<DropDown name='brands' value={this.state.CurrentBrand} onChange={onChange}>
                  <option value='0' />
                  {brands.map((val, key) => {
                    return <option value={val.Id} key={key}>{translation(val.Name)}</option>
                  })}
                </DropDown>)}
                {!this.state.disabled && (<AddButton onClick={addItem} />)}
              </Inline>
            </div>
          )}
        </Panel>
      </div>
    )
  }

  renderActive () {
    let quality = this.state.activeItem

    const onDelete = () => {
      this.setState({
        confirmDelete: {
          open: true
        }
      })
    }

    return (
      <Panel title={translation('295')} helpText={translation('15170')}>
        <Switch name='Active' onChange={this.onInputChange} checked={quality.Active} disabled={this.state.disabled} labelText={translation('295')} helpText={translation('1967')} />
        <Text name='Name' value={quality.Name || ''} onChange={this.onInputChange} onBlur={this.onInputBlur} disabled={this.state.disabled} labelText={translation('30')} />
        {!this.state.disabled && <Button style='alert' onClick={onDelete} labelText={translation('1812')} />}
      </Panel>
    )
  }

  renderCustomers () {
    // if (hasAccess([6], this.props.auth.user.UserType) || this.props.partners) return null
    // if (hasAccess([2, 3], this.props.auth.user.UserType)) return null
    let quality = this.state.activeItem
    let { customers } = this.props
    // Add customers
    const addItem = () => {
      if (this.state.disabled) return null
      let id = parseInt(this.state.CurrentCustomer)
      if (id !== 0) {
        let quality = { ...this.state.activeItem }
        quality.QualityCheckCustomers.push({
          CustomerId: id
        })
        this.updateQualityCheckSettings(quality).then(() => {
          this.setState({
            CurrentCustomer: '0'
          })
        })
      }
    }
    const onChange = (e) => {
      if (e.target.name === 'customer') {
        this.setState({
          CurrentCustomer: e.target.value
        })
      }
    }
    // Render customer
    const renderCustomer = (val, key) => {
      // Delete item
      const deleteItem = (e) => {
        if (this.state.disabled) return null
        let quality = { ...this.state.activeItem }
        quality.QualityCheckCustomers[key].Active = false
        this.updateQualityCheckSettings(quality)
      }
      // Return
      return (
        <Inline block fillChildNum={[0]} key={key}>
          {val.CustomerName}
          {!this.state.disabled && (<RemoveButton minus size='m' onClick={deleteItem} />)}
        </Inline>
      )
    }

    // Return
    return (
      <div className='customer-selection'>
        <Panel title={translation('14')} helpText={translation('15171')}>
          {quality.QualityCheckCustomers.map(renderCustomer)}
          <Inline block fillChildNum={[0]}>
            {!this.state.disabled && (<DropDown name='customer' value={this.state.CurrentCustomer} onChange={onChange}>
              <option value='0' />
              {customers.map((val, key) => {
                return <option value={val.CustomerId} key={key}>{val.Name}</option>
              })}
            </DropDown>)}
            {!this.state.disabled && (<AddButton onClick={addItem} />)}
          </Inline>
        </Panel>
      </div>
    )
  }

  renderOrderTypes () {
    let quality = this.state.activeItem

    // let { price } = this.state
    // Return
    return (
      <Panel title={translation('525')} helpText={translation('1939')}>
        <Radio id='ordertype_2' name='QualityCheckOrderType' value='2' onChange={this.changeType} checked={quality.QualityCheckOrderType === 2} disabled={this.state.disabled} labelText={translation('785')} />
        <Radio id='ordertype_1' name='QualityCheckOrderType' value='1' onChange={this.changeType} checked={quality.QualityCheckOrderType === 1} disabled={this.state.disabled} labelText={translation('71')} />
        <Radio id='ordertype_3' name='QualityCheckOrderType' value='3' onChange={this.changeType} checked={quality.QualityCheckOrderType === 3} disabled={this.state.disabled} labelText={translation('13361')} />
        <Radio id='ordertype_4' name='QualityCheckOrderType' value='4' onChange={this.changeType} checked={quality.QualityCheckOrderType === 4} disabled={this.state.disabled} labelText={translation('13360')} />
        <Radio id='ordertype_5' name='QualityCheckOrderType' value='5' onChange={this.changeType} checked={quality.QualityCheckOrderType === 5} disabled={this.state.disabled} labelText={translation('301')} />
      </Panel>
    )
  }

  onPortalClose (type) {
    this.setState({
      [type]: {
        ...this.state[type],
        open: false
      }
    })
  }

  onConfirm () {
    this.onPortalClose('confirmDelete')
    let quality = { ...this.state.activeItem }
    quality.IsDeleted = true
    this.updateQualityCheckSettings(quality).then(() => {
      this.props.updateList()
    })
  }
  render () {
    if (this.state.activeItem.QualityCheckModelId === 0 && this.state.disabled) {
      return (
        // None selected
        <div />
      )
    }
    let quality = this.state.activeItem

    const onTasksChange = (tasks) => {
      this.setState({
        activeItem: {
          ...this.state.activeItem,
          QualityCheckTasks: tasks
        }
      })
      let qualityCopy = { ...this.state.activeItem }
      qualityCopy.QualityCheckTasks = tasks
      this.updateQualityCheckSettings(qualityCopy)
    }

    const updateGroups = (groups) => {
      let activeItem = {
        ...this.state.activeItem,
        QualityCheckTaskGroups: groups
      }
      this.updateQualityCheckSettings(activeItem)
    }

    let showCustomOptions = quality.Name !== null && !this.state.isAgreement && !this.state.isMainAgreement
    // showCustomOptions = true // temporary

    const renderCustomGroups = () => {
      // Filter custom groups.
      let customGroups = quality.QualityCheckTaskGroups.filter(g => g.Type === 5)
      return customGroups.map(g => (
        <QualityCheckSettingsBox
          key={'group_' + g.QualityCheckTaskGroupId}
          taskType={5}
          group={g}
          quality={quality}
          isLoaded={this.state.isLoaded}
          onChange={onTasksChange}
          updateGroups={updateGroups}
        />
      ))
    }

    const renderAddCustom = () => {
      const addGroup = () => {
        let newGroup = {
          QualityCheckTaskGroupId: 0,
          Type: 5,
          CustomName: translation(17856)
        }
        let data = { ...this.state.activeItem, QualityCheckTaskGroups: [ ...this.state.activeItem.QualityCheckTaskGroups, newGroup ] }
        this.updateQualityCheckSettings(data)
      }

      return (
        <Panel title={17856}>
          <Button style='link' labelText={1208} onClick={addGroup} />
        </Panel>
      )
    }

    return (
      <div ref={node => { this.qualityRef = node }}>
        <Row>
          {!this.state.isLoaded && (
            <p className='loading'>
              <Divider noLine />
              <div className='animated-background'>
                <i className='fa fa-spinner fa-spin fa-3x fa-fw' />
              </div>
            </p>
          )}
          {this.state.isLoaded && this.dimensionShow([[0, 640]]) && (
            [
              <Col key={0}>
                <QualityCheckSettingsBox taskType={1} quality={quality} isLoaded={this.state.isLoaded} onChange={onTasksChange} />
                <QualityCheckSettingsBox taskType={2} quality={quality} isLoaded={this.state.isLoaded} onChange={onTasksChange} />
                <QualityCheckSettingsBox taskType={3} quality={quality} isLoaded={this.state.isLoaded} onChange={onTasksChange} />
                <QualityCheckSettingsBox taskType={4} quality={quality} isLoaded={this.state.isLoaded} onChange={onTasksChange} />
                {quality.Department === 1 && renderCustomGroups()}
                {quality.Department === 1 && renderAddCustom()}
              </Col>,
              showCustomOptions && (
                <Col key={1}>
                  {this.renderActive()}
                  {this.renderOrderTypes()}
                  {this.renderBrands()}
                  {this.renderCustomers()}
                </Col>
              )
            ]
          )}
          {this.state.isLoaded && !this.dimensionShow([[0, 640]]) && (
            <div className='qualitycheck__screen__page'>
              {showCustomOptions ? (
                <Col>
                  {this.renderActive()}
                  {this.renderOrderTypes()}
                  {this.renderBrands()}
                  {this.renderCustomers()}
                </Col>
              ) : <div />}

              <div className='qualitycheck__screen__content'>
                <div className='qualitycheck__screen__boxes'>
                  <QualityCheckSettingsBox taskType={1} quality={quality} isLoaded={this.state.isLoaded} onChange={onTasksChange} />
                  <QualityCheckSettingsBox taskType={2} quality={quality} isLoaded={this.state.isLoaded} onChange={onTasksChange} />
                  <QualityCheckSettingsBox taskType={3} quality={quality} isLoaded={this.state.isLoaded} onChange={onTasksChange} />
                  <QualityCheckSettingsBox taskType={4} quality={quality} isLoaded={this.state.isLoaded} onChange={onTasksChange} />
                  {quality.Department === 1 && renderCustomGroups()}
                </div>
                <Col>
                  {quality.Department === 1 && renderAddCustom()}
                </Col>
              </div>
            </div>
          )}

          {this.state.confirmDelete.open && (
            <Portal className='confirm_popup' onPortalClose={this.onPortalClose.bind(this, 'confirmDelete')}>
              <Confirm confirm={this.onConfirm.bind(this)} notConfirm={this.onPortalClose.bind(this, 'confirmDelete')} />
            </Portal>
          )}
        </Row>
      </div>
    )
  }
}

function mapStateToProps (state) {
  return {
    auth: state.auth,
    customers: state.common.customers,
    brands: state.common.brands
  }
}

export default connect(mapStateToProps, {
  getQualityCheckSettings,
  getAgreementQualityCheckSettings,
  updateQualityCheckSettings,
  getShopCustomerAgreement,
  getPriceList,
  getBrands
})(QualityCheckSettingsChild)



// WEBPACK FOOTER //
// ./src/app/pages/QualityCheckSettings/QualityCheckSettingsChild/index.js